jQuery(function () {
  /* -----------------------------------
       Hilfsfunktion: Debounce via rAF
    ----------------------------------- */
  function rafDebounce(callback) {
    var ticking = false
    return function () {
      if (!ticking) {
        ticking = true
        requestAnimationFrame(function () {
          callback()
          ticking = false
        })
      }
    }
  }

  /* -----------------------------------
       1. Rahmen letzter Event-Block auch mobile ausblenden
    ----------------------------------- */
  jQuery(document).ready(function (jQuery) {
    function removeBorder() {
      if (window.matchMedia('(max-width: 820px)').matches) {
        if (jQuery('.eventshome').length || jQuery('.eventcontainer').length) {
          jQuery('.eventshome').last().find('.bordertop').css('border-bottom-style', 'none')
          jQuery('.eventcontainer').last().find('.bordertop').css('border-bottom-style', 'none')
        }
      }
    }

    // Interval, falls Elemente noch nicht geladen sind
    var interval = setInterval(function () {
      removeBorder()
      if (jQuery('.eventshome').length || jQuery('.eventcontainer').length) {
        clearInterval(interval)
      }
    }, 200)

    jQuery(window).resize(removeBorder)
    removeBorder()
  })

  /* -----------------------------------
       2. Social Media & Sprachnavi Hover
    ----------------------------------- */
  jQuery('#naviblende p a').each(function () {
    var $link = jQuery(this)
    var $img = $link.find('img')
    var originalSrc = $img.attr('src')
    var hoverSrc = originalSrc.replace('icon-schwarz', 'icon-weiss')

    $link.hover(
      function () {
        $img.attr('src', hoverSrc)
      },
      function () {
        if (window.location.href !== $link.attr('href')) $img.attr('src', originalSrc)
      },
    )

    if (window.location.href === $link.attr('href')) {
      $img.attr('src', hoverSrc)
    }
  })

  /* -----------------------------------
       3. Hauptnavi in die Blende verschieben
    ----------------------------------- */
  jQuery('header .col.span_9.col_last').first().attr('id', 'naviMain')
  ;(function checkAndMoveNav() {
    if (jQuery('#naviMain nav').length) {
      jQuery('#naviMain nav').appendTo('#naviContainer')
    } else {
      setTimeout(checkAndMoveNav, 500)
    }
  })()

  var $fixedDiv = jQuery('#naviblende')
  var $spacer = jQuery('#spacer')
  var lastScrollY = 0
  var originalOffsetTop = $fixedDiv.offset().top
  var isFixed = false

  jQuery(window).on('resize', function () {
    originalOffsetTop = $fixedDiv.offset().top
    applyFixed()
  })

  function applyFixed() {
    var currentScrollY = jQuery(window).scrollTop()

    if (currentScrollY > lastScrollY && currentScrollY >= originalOffsetTop) {
      if (!isFixed) {
        $spacer.css({
          height: $fixedDiv.outerHeight() + 'px',
          display: 'block',
        })
        $fixedDiv.addClass('fixed')
        isFixed = true
      }
    } else if (currentScrollY < lastScrollY && currentScrollY <= originalOffsetTop) {
      if (isFixed) {
        $fixedDiv.removeClass('fixed')
        $spacer.css('display', 'none')
        isFixed = false
      }
    }
    lastScrollY = currentScrollY
  }

  jQuery(window).on('scroll', rafDebounce(applyFixed))
  applyFixed()

  /* -----------------------------------
       4. Event-Link "toggle" Parameter setzen
    ----------------------------------- */
  // jQuery('.event').each(function () {
  //   var $link = jQuery(this).find('a')
  //   if ($link.length) {
  //     var emText = $link.find('em').text().trim().toLowerCase().replace(/\s+/g, '-')
  //     if (emText) {
  //       var url = new URL($link.attr('href'), window.location.origin)
  //       url.searchParams.set('toggle', emText)
  //       $link.attr('href', url.toString())
  //     }
  //   }
  // })

  /* -----------------------------------
       5. Scroll zu passendem Toggle
    ----------------------------------- */
  var searchString = new URLSearchParams(window.location.search).get('toggle')
  if (searchString) {
    searchString = decodeURIComponent(searchString).replace(/-/g, ' ')
    jQuery('.toggle-heading').each(function () {
      var eventText = jQuery(this)
        .contents()
        .filter(function () {
          return this.nodeType === Node.TEXT_NODE
        })
        .text()
        .trim()
        .toLowerCase()

      if (eventText.includes(searchString.toLowerCase())) {
        var targetElement = jQuery(this).parents().eq(7)
        if (targetElement.length) {
          setTimeout(function () {
            jQuery('html, body').animate({ scrollTop: targetElement.offset().top }, 'slow')
          }, 500)
        }
        return false
      }
    })
  }

  /* -----------------------------------
       6. Alle PDF-Links in neuem Tab
    ----------------------------------- */
  jQuery('a[href$=".pdf"]').attr('target', '_blank')

  /* -----------------------------------
       7. Termin-Share-Link setzen
    ----------------------------------- */
  // setTimeout(function () {
  //   jQuery('.eventcontainer').each(function () {
  //     var $container = jQuery(this)
  //     var eventDay = $container.find('h3:not(".toggle-title")').text()
  //     var eventDate = $container
  //       .find('h3 + table td:first-child')
  //       .html()
  //       .replace(/<br\s*\/?>/gi, ' ')
  //     var eventType = $container.find('h3 + table td+td').text()
  //     var toggleHeadingLink = $container.find('.toggle a.toggle-heading')
  //     var eventParameter = toggleHeadingLink.text().trim().toLowerCase().replace(/\s+/g, '-')
  //     var shareMailLink = $container.find('.terminshare')

  //     if (toggleHeadingLink.length) {
  //       var bodyText = 'https://museum-lindwurm.ch.ownb.it/veranstaltungen?toggle=' + eventParameter
  //       var subjectText =
  //         'Museum Lindwurm > ' +
  //         eventDay +
  //         '2025, ' +
  //         eventDate +
  //         ': ' +
  //         eventType +
  //         ' ' +
  //         toggleHeadingLink.text().trim()
  //       var mailtoLink =
  //         'mailto:?subject=' +
  //         encodeURIComponent(subjectText) +
  //         '&body=' +
  //         encodeURIComponent(bodyText)
  //       shareMailLink.attr('href', mailtoLink)
  //     }
  //   })
  // }, 500)

  /* -----------------------------------
       8. Zeilen zählen bei toggle-heading
    ----------------------------------- */
  jQuery('a.toggle-heading').each(function () {
    var lineHeight = parseFloat(jQuery(this).css('line-height'))
    var lines = Math.round(jQuery(this).height() / lineHeight)
    var parent = jQuery(this).parent()
    parent.removeClass('einzeile zweizeilen dreizeilen mehrzeilen')
    if (lines === 2) parent.addClass('zweizeilen')
    else if (lines === 3) parent.addClass('dreizeilen')
    else if (lines > 3) parent.addClass('mehrzeilen')
  })

  /* -----------------------------------
       9. Nächstes Event in #sonderoffen anzeigen
    ----------------------------------- */
  var today = new Date()
  today.setHours(0, 0, 0, 0)
  var nearestFutureDate = null,
    nearestTime = '',
    linkHref = '',
    linkInnerHtml = ''

  jQuery('.event').each(function () {
    var $event = jQuery(this)
    var $h3 = $event.find('h3').first()
    var text = $h3.text()
    var match = text.match(/(\d{1,2})\.(\d{1,2})\./)

    if (match) {
      var day = parseInt(match[1], 10)
      var month = parseInt(match[2], 10)
      var eventDate = new Date(today.getFullYear(), month - 1, day)
      eventDate.setHours(0, 0, 0, 0)

      if (eventDate >= today && (!nearestFutureDate || eventDate < nearestFutureDate)) {
        nearestFutureDate = eventDate
        var $table = $h3.nextAll('table').first()
        var $firstTd = $table.find('td:first-child').first()
        if ($firstTd.length) {
          var tdText = $firstTd.text().trim()
          // Erfasse den kompletten Zeitbereich inkl. Bindestrich und optional Minuten
          var timeMatch = tdText.match(/(\d{1,2}(?::\d{2})?\s*(?:–|-)\s*\d{1,2}(?::\d{2})?)\s*UHR/i)
          if (timeMatch) nearestTime = timeMatch[1]
        }

        var $secondTd = $table.find('td:first-child').next()
        if ($secondTd.length) {
          var $link = $secondTd.find('a').first()
          if ($link.length) {
            linkHref = $link.attr('href') || '#'
            linkInnerHtml = $link
              .html()
              .replace(/<br\s*\/?>/gi, ' ')
              .trim()
          }
        }
      }
    }
  })

  if (nearestFutureDate && linkHref) {
    var dateText = nearestFutureDate.toLocaleDateString('de-DE', {
      weekday: 'long',
      day: '2-digit',
      month: 'long',
      year: 'numeric',
    })
    dateText = dateText.charAt(0).toUpperCase() + dateText.slice(1)
    var fullText = dateText + (nearestTime ? ', ' + nearestTime + ' Uhr' : '')
    var finalLinkText = '<em>' + fullText + '</em>' + ' ' + linkInnerHtml
    jQuery('#sonderoffen').html(
      '<h2 style="text-align: center;"><a href="' + linkHref + '">' + finalLinkText + '</a></h2>',
    )
  } else {
    jQuery('#sonderoffen').html(
      '<h2 style="text-align: center;">Kein kommendes Event gefunden.</h2>',
    )
  }

  /* -----------------------------------
       10. "Digital" Menüpunkt markieren
    ----------------------------------- */
  if (window.location.href.indexOf('digital-') !== -1) {
    jQuery('#naviContainer .sf-menu li:last-child').addClass('current_page_item')
  }
})
